
import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CatalogoService } from './catalogo-service';
import { Data } from './models/response-catalog-model';
import { CommonModule } from '@angular/common';
import { GatewayService } from './gateway-service';
import { AlertComponent } from "../../commons/components/alert/alert.component";
import { AlertService } from '../../commons/components/alert/alert.service';
import { v4 as uuidv4 } from 'uuid';
import { AuthService } from '../../commons/services/auth.service';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { ElectronicDemandService } from '../demanda/electronicDemand.service';
import { Documents } from '../../commons/class/archivo.inteface';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { Router } from '@angular/router';
import { PromotionInsertCommand } from '../../commons/class/promotion.class';
import { AcuseDTO } from '../../commons/class/Acuse.class';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../../commons/components/dialog/dialog.component';
import { AppModule } from '../../app-module';
import { ENV_TOKEN } from '../../app-module.token';
import { FirmadorService } from '../../commons/shared/firmador.service';



@Component({
  selector: 'oaj-promocion-itx',
  imports: [ReactiveFormsModule, CommonModule, AlertComponent, ListaArchivosComponent, LoaderComponent, AppModule],
  templateUrl: 'electronicPromotion.component.html',
  styleUrls: ['electronicPromotion.component.css'],
  providers: [AuthService, ModalIframeService, ConfirmationDialogService, ElectronicDemandService]
})
export class ElectronicPromotionComponent implements OnInit {
  loading = false;
  formulario: FormGroup;
  idAmbito: number | null = null;
  idClasificacion: number | null = null;
  idTipoFiltro: number | null = null;
  tiposFiltros: Data[] = [];
  entidadesFederativasCircuito: Data[] = [];
  idEntidadFederativa: number | null = null;
  circuitosTipoOrganismo: Data[] = [];
  materiasTipoOrganismo: Data[] = [];
  organismoTipoCircuito: Data[] = [];
  tiposAsuntoOrganismo: Data[] = [];
  mostrarTipoProcedimiento = false;
  tiposProcedimientos: Data[] = [];
  idTipoProcedimiento = 0;
  idAsuntoNeun = 0;
  expedienteEncontrado = false;
  mensajeExpediente = '';
  cargaArchivos = false;
  private constService: any;
  uuid = "0";
  public lstDocumentos: any[] = [];
  isLoadingFile = false;
  sMensajeLoad = "Consultando archivos...";
  acuse!: AcuseDTO;
  itipovistaorgano: number | null = null;
  bAcceptDocx = true;
  sFormatos='PDF';

  private fb: FormBuilder = inject(FormBuilder);
  private catalogService: CatalogoService = inject(CatalogoService);
  private gatewayService: GatewayService = inject(GatewayService);
  private alertService: AlertService = inject(AlertService);
  private authService: AuthService = inject(AuthService);
  private modalIframeService: ModalIframeService = inject(ModalIframeService);
  private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private router: Router = inject(Router);
  private modalService: NgbModal = inject(NgbModal);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  readonly environment = inject(ENV_TOKEN);
  private firmador = inject(FirmadorService);

  constructor() {
    this.formulario = this.fb.group({
      tipoFiltro: [undefined],
      tipoOrgano: [undefined],
      materiaTipo: [undefined],
      organoJurisdiccional: [undefined],
      tiposAsunto: [undefined],
      tipoProcedimiento: [undefined],
      numeroExpediente: [''],
      //ART - Se comenta para la primera etapa, se habilitará en próximas etapas cuando se integre con el expediente electrónico
      //  numeroExpedienteOIJ:[''],
      // existeEE:[false],
      // urlEE:[{value:'', disabled: true}]

    });
    this.constService = this.environment;

    this.idAmbito = 1;
    this.idClasificacion = 11;
    this.idTipoFiltro = 11;
    this.itipovistaorgano = this.authService.getClasificacionOrg() == 18 ? 2 : 3;

    this.catalogService.getTypesFilters({ IdAmbito: this.idAmbito!, IdClasificacion: this.idClasificacion!, IdTipoFiltro: this.idTipoFiltro! }).subscribe({
      next: (response) => {
        this.tiposFiltros = Array.isArray(response.Data.$values) ? response.Data.$values : [];
      },
      error: (err) => {
        console.error('Error al obtener tipos filtros', err)
      }
    });
  }

  /**
   * Función para manejar el cambio en el campo de número de expediente, se valida que el número de expediente tenga una longitud mayor a 5 caracteres, si es así se hace una consulta al servicio para verificar si existe un expediente electrónico asociado al número de expediente ingresado, dependiendo del resultado se muestra un mensaje indicando si se encontró o no el expediente electrónico, si ocurre un error durante la consulta se muestra un mensaje de error
   */
  ngOnInit(): void {
    if(this.bAcceptDocx){
      this.sFormatos = 'PDF, DOCX';
    }
    else{
      this.sFormatos='PDF'
    }

    this.formulario.get('tipoFiltro')?.valueChanges.subscribe((idEstadoSeleccionado: number) => {
      this.formulario.get('tipoOrgano')?.setValue(undefined);
      this.formulario.get('materiaTipo')?.setValue(undefined);
      this.idEntidadFederativa = null;
      this.entidadesFederativasCircuito = [];
      this.circuitosTipoOrganismo = [];
      this.expedienteEncontrado = false;

      if (idEstadoSeleccionado) {
        this.catalogService.getEntitiesFederalCircuit({
          IdAmbito: this.idAmbito!,
          IdClasificacion: this.idClasificacion!,
          IdTipoFiltro: this.idTipoFiltro!,
          IdCircuito: Number(idEstadoSeleccionado)
        }).subscribe({
          next: (respuesta) => {
            this.entidadesFederativasCircuito = Array.isArray(respuesta.Data.$values) ? respuesta.Data.$values : [];

            if (this.entidadesFederativasCircuito.length > 0) {
              this.idEntidadFederativa = this.entidadesFederativasCircuito[0].Id

              this.catalogService.getTypesOrganismCircuit({
                IdAmbito: this.idAmbito!,
                IdClasificacion: this.idClasificacion!,
                IdTipoFiltro: this.idTipoFiltro!,
                IdCircuito: Number(idEstadoSeleccionado),
                IdEstado: this.idEntidadFederativa
              }).subscribe({
                next: (response) => {
                  const filter = [2, 4, 65, 11, 29, 32, 340, 342];
                  this.circuitosTipoOrganismo = Array.isArray(response.Data?.$values) ? response.Data.$values : [];
                  this.circuitosTipoOrganismo = this.circuitosTipoOrganismo.filter(cto => filter.find(i => +i === +cto.Id));
                  this.changeDetectorRef.detectChanges();
                },
                error: (err) => {
                  console.error('Error al cargar datos tipo de organismo por circuito:', err.message);
                }
              });

            }
            else {
              console.error('No hay datos de Entidades Federativas por Circuito');
            }
          },
          error: (err) => {
            console.error('Error al cargar entidades federativas por circuito:', err.message);
          }
        });
      }
    });


    this.formulario.get('tipoOrgano')?.valueChanges.subscribe((idTipoOrganoSeleccionado: number) => {
      this.formulario.get('materiaTipo')?.setValue(undefined);
      this.materiasTipoOrganismo = [];
      this.formulario.get('organoJurisdiccional')?.setValue(undefined);
      this.organismoTipoCircuito = [];
      const idEstado = Number(this.formulario.get('tipoFiltro')?.value);
      this.expedienteEncontrado = false;
      if (this.idEntidadFederativa && idTipoOrganoSeleccionado) {
        this.catalogService.getSubjectOrganismType({
          IdAmbito: this.idAmbito!,
          IdClasificacion: this.idClasificacion!,
          IdTipoFiltro: this.idTipoFiltro!,
          IdCircuito: idEstado,
          IdEstado: this.idEntidadFederativa,
          IdTipoOrganismo: Number(idTipoOrganoSeleccionado)
        }).subscribe({
          next: (respuesta) => {
            this.materiasTipoOrganismo = Array.isArray(respuesta.Data?.$values) ? respuesta.Data.$values : [];
            this.changeDetectorRef.detectChanges();
          },
          error: (err) => {
            console.error('Error al cargar materias por tipo de organismo:', err.message);
          }
        });
      }
    });


    this.formulario.get('materiaTipo')?.valueChanges.subscribe((idMateriaSeleccionado: number) => {
      this.formulario.get('organoJurisdiccional')?.setValue(undefined);
      this.organismoTipoCircuito = [];
      const idEstado = Number(this.formulario.get('tipoFiltro')?.value);
      const tipoOrgano = Number(this.formulario.get('tipoOrgano')?.value);
      this.expedienteEncontrado = false;

      if (this.idEntidadFederativa && idMateriaSeleccionado && tipoOrgano) {
        this.catalogService.getOrganismTypeOrganCircuit({
          IdAmbito: this.idAmbito!,
          IdClasificacion: this.idClasificacion!,
          IdTipoFiltro: this.idTipoFiltro!,
          IdCircuito: idEstado,
          IdEstado: this.idEntidadFederativa,
          IdTipoOrganismo: tipoOrgano,
          IdMateria: Number(idMateriaSeleccionado),
          itipovistaorgano: this.itipovistaorgano ?? 0
        }).subscribe({
          next: (respuesta) => {
            this.organismoTipoCircuito = Array.isArray(respuesta.Data?.$values) ? respuesta.Data.$values : [];
            this.changeDetectorRef.detectChanges();
          },
          error: (err) => {
            console.error('Error al cargar organismo tipo de organismo por circuito:', err.message);
          }
        });
      }
    });


    this.formulario.get('organoJurisdiccional')?.valueChanges.subscribe((idOrganoJurisdiccionalSeleccionado: number) => {
      this.formulario.get('tiposAsunto')?.setValue(undefined);
      this.tiposAsuntoOrganismo = [];
      const idEstado = Number(this.formulario.get('tipoFiltro')?.value);
      const tipoOrgano = Number(this.formulario.get('tipoOrgano')?.value);
      const idMateria = Number(this.formulario.get('materiaTipo')?.value);
      this.expedienteEncontrado = false;

      if (this.idEntidadFederativa && idOrganoJurisdiccionalSeleccionado && tipoOrgano) {
        this.catalogService.getMatterTypeOrganism({
          IdAmbito: this.idAmbito!,
          IdClasificacion: this.idClasificacion!,
          IdTipoFiltro: this.idTipoFiltro!,
          IdCircuito: idEstado,
          IdEstado: this.idEntidadFederativa,
          IdTipoOrganismo: tipoOrgano,
          IdMateria: idMateria,
          IdOrgano: Number(idOrganoJurisdiccionalSeleccionado),
          itipovistaorgano: this.itipovistaorgano ?? 0

        }).subscribe({
          next: (respuesta) => {
            this.tiposAsuntoOrganismo = Array.isArray(respuesta.Data?.$values) ? respuesta.Data.$values : [];
            this.changeDetectorRef.detectChanges();
          },
          error: (err) => {
            console.error('Error al cargar organismo tipo de asunto por organismo:', err.message);
          }
        });
      }
    });

    this.formulario.get('tiposAsunto')?.valueChanges.subscribe((idTiposAsuntoSeleccionado: number) => {
      this.formulario.get('tipoProcedimiento')?.setValue(undefined);
      this.tiposProcedimientos = [];
      this.expedienteEncontrado = false;

      if (idTiposAsuntoSeleccionado) {
        this.catalogService.getProcedureType({
          IdTipoAsunto: Number(idTiposAsuntoSeleccionado)
        }).subscribe({
          next: (respuesta) => {
            this.tiposProcedimientos = Array.isArray(respuesta.Data?.$values) ? respuesta.Data.$values : [];
            this.mostrarTipoProcedimiento = (this.tiposProcedimientos?.length ?? 0) > 0;
            if (!this.mostrarTipoProcedimiento) {
              this.formulario.get('tipoProcedimiento')?.setValue('');
            }
            else {
              this.formulario.get('tipoProcedimiento')?.valueChanges.subscribe((idTipoProcedimientoSeleccionado: number) => {
                this.idTipoProcedimiento = Number(idTipoProcedimientoSeleccionado) || 0;
              });
            }
            this.changeDetectorRef.detectChanges();
          },
          error: (err) => {
            console.error('Error al cargar tipos de procedimientos:', err.message);
          }
        });
      }
    });
    //ART - Se comenta para la primera etapa, se habilitará en próximas etapas cuando se integre con el expediente electrónico
    /*
     this.formulario.get('existeEE')?.valueChanges.subscribe((checked: boolean) => {
        if (checked){
         this.formulario.get('urlEE')?.enable();
        }
        else{
             this.formulario.get('urlEE')?.reset();
             this.formulario.get('urlEE')?.disable();
        }
        this.changeDetectorRef.detectChanges();
     });
     */

  }

  /**
   * Función para buscar el expediente utilizando los filtros seleccionados, se construye un objeto de request con los valores seleccionados en el formulario, se llama al método consultAffair del servicio GatewayService para realizar la consulta, si la consulta es exitosa y se encuentra el expediente se muestra un mensaje de éxito y se asigna el número de asunto NEUN a la propiedad idAsuntoNeun, si no se encuentra el expediente se muestra un mensaje de error, si ocurre un error durante la consulta se muestra un mensaje de error
   */
  buscarExpediente(): void {

    const request = {
      idMateria: Number(this.formulario.value.materiaTipo),
      idTipoAsunto: Number(this.formulario.value.tiposAsunto),
      idOrgano: Number(this.formulario.value.organoJurisdiccional),
      idTipoProcedimiento: Number(this.formulario.value.tipoProcedimiento),
      numeroExpediente: this.formulario.value.numeroExpediente
    };

    this.gatewayService.consultAffair(request).subscribe({
      next: (response) => {
        this.expedienteEncontrado = false;
        if (response.succcess && response.data?.neun) {
          this.expedienteEncontrado = true;
          this.mensajeExpediente = 'La búsqueda fue exitosa, ya puede cargar los archivos.';
          this.alertService.success(this.mensajeExpediente, { autoClose: true, keepAfterRouteChange: false });
          this.idAsuntoNeun = response.data.neun;
        } else {
          this.expedienteEncontrado = false;
          this.mensajeExpediente = 'El expediente no fue localizado.';
          this.alertService.error(this.mensajeExpediente, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (err) => {
        console.error(JSON.stringify(err));
        this.loading = false;
        this.expedienteEncontrado = false;
        this.mensajeExpediente = 'El expediente no fue localizado.';
        this.alertService.error(this.mensajeExpediente, { autoClose: true, keepAfterRouteChange: false });
      }
    });
  }

  /**
   *  Función para cargar archivos, se construye la url para la carga de archivos utilizando los datos del usuario y la pantalla, se abre una modal con un iframe para la carga de archivos, al cerrar la modal se actualiza la lista de documentos asociados a la pantalla, si ocurre un error al abrir la modal se muestra un mensaje de error en la consola
   */
  cargaArchivo(): void {

    const IdPantalla = 0;
    const TipoArchivo = this.constService.TipoDoctos.Promociones;
    let FirmaObligatoria = 1;
    const PermisoNoFirma = this.authService.getbPermisoNoFirma();
    if (PermisoNoFirma) {
      FirmaObligatoria = 2;
    }
    else {
      this.openWindowFirma();
      FirmaObligatoria = 1;
      return;
    }
    if (this.uuid == "0") {
      this.uuid = uuidv4();
    }

    const urlFirma = `${this.constService.baseUrlFirma}?userName=${this.authService.getUserName()}&idUser=${this.authService.getIdUser()}&idOrganismo=${this.authService.getIdOrgan()}&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&fo=${FirmaObligatoria}&ma=1`;


    this.modalIframeService.open('Carga de documentos',
      urlFirma,
      'Cerrar',
      'xl').then((closed) => {
        if (closed) {
          this.GetDocumentosPantalla(this.uuid).then((resolve) => {
            this.lstDocumentos = resolve;
          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
  }

  /**
   * Función para eliminar documentos de la pantalla, se muestra un mensaje de confirmación antes de proceder con la eliminación, si el usuario confirma se llama al método EliminarDocumentosPantalla del servicio, si la eliminación es exitosa se muestra un mensaje de éxito y se actualiza la lista de documentos
   * @param Documento 
   */
  EliminarDocumentosPantalla(Documento: any): void {
    this.modalConfirmacionService.confirm('Confirmación',
      'Va eliminar el documento con nombre original ' + Documento.NombreOriginal + ', ¿desea continuar?',
      'Aceptar',
      'Cancelar',
      'sm').then((confirmed) => {
        if (confirmed) {
          this._service.EliminarDocumentosPantalla(Documento.IdDocumento).subscribe({
            next: (response: any) => {
              if (response.succcess) {
                this.alertService.success("Se eliminó correctamente el documento", { autoClose: true, keepAfterRouteChange: false });
                this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                  this.lstDocumentos = resolve;
                });
              }
            },
            error: (error) => {
              this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
              return;
            }
          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));

  }

  /** 
   * Función para obtener los documentos asociados a la pantalla, se muestra un indicador de carga mientras se realiza la consulta, se llama al método getDocumentosPantallaGuid del servicio para obtener los documentos, si la consulta es exitosa se asignan los documentos a la lista y se oculta el indicador de carga, si ocurre un error durante la consulta se muestra un mensaje de error y se oculta el indicador de carga
   * @param uuid 
   * @returns Promise<Documents[]>
   */
  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

    return new Promise((resolve) => {
      this.isLoadingFile = true;
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            this.isLoadingFile = false;

            resolve(response);
          }
          else {
            this.isLoadingFile = false;
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoadingFile = false;
          resolve([]);
        });

    });
  }

  /**
   * Función para enviar la promoción, se muestra un indicador de carga mientras se realiza la solicitud, se construye un objeto de request con los valores del formulario, se llama al método insertPromotion del servicio para enviar la promoción, si la solicitud es exitosa se muestra un mensaje de éxito y se reinicia el formulario, si ocurre un error durante la solicitud se muestra un mensaje de error y se oculta el indicador de carga
   * @returns 
   */
  EnviarPromocion() {
    this.loading = true;

    const requestRegistroPromocion: PromotionInsertCommand = new PromotionInsertCommand()

    const idMateria = this.formulario.get('materiaTipo')?.value;

    if (idMateria === undefined || idMateria === null || idMateria === 0) {
      this.loading = false;
      this.alertService.warn("No ha seleccionado el tipo de Materia, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroPromocion.catMateriaIdDes = Number(idMateria);
    }

    const idOrgano = this.formulario.get('organoJurisdiccional')?.value;

    if (idOrgano === undefined || idOrgano === null || idOrgano === 0) {
      this.loading = false;
      this.alertService.warn("No ha seleccionado el Organo, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroPromocion.catOrganismoIdDes = Number(idOrgano);
    }


    const idTipoAsunto = this.formulario.get('tiposAsunto')?.value;

    if (idTipoAsunto === undefined || idTipoAsunto === null || idTipoAsunto === 0) {
      this.loading = false;
      this.alertService.warn("No ha seleccionado el Tipo Asunto, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroPromocion.catTipoAsuntoIdDes = Number(idTipoAsunto);
    }


    requestRegistroPromocion.catTipoProcedimientoDes = Number(this.formulario.get('tipoProcedimiento')?.value);


    const numeroExpediente = this.formulario.get('numeroExpediente')?.value;

    if (!numeroExpediente || numeroExpediente.trim() === '') {
      this.loading = false;
      this.alertService.warn("No ha capturado el Numero de Expediente, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroPromocion.numExpedienteDes = numeroExpediente;
    }

    //ART - Se comenta para la primera etapa, se habilitará en próximas etapas cuando se integre con el expediente electrónico
    /*     const valorNumeroExpedienteOIJ = this.formulario.get('numeroExpedienteOIJ')?.value;
        requestRegistroPromocion.numeroExpedienteOIJ = valorNumeroExpedienteOIJ && valorNumeroExpedienteOIJ.trim() !== '' ? valorNumeroExpedienteOIJ : '0';
        requestRegistroPromocion.existeEE = this.formulario.get('existeEE')?.value;
        requestRegistroPromocion.urlEE = this.formulario.get('urlEE')?.value; */
    requestRegistroPromocion.numeroExpedienteOIJ = '0';
    requestRegistroPromocion.existeEE = false;
    requestRegistroPromocion.urlEE = '';

    if (this.idAsuntoNeun === undefined || this.idAsuntoNeun === null || this.idAsuntoNeun === 0) {
      this.loading = false;
      this.alertService.warn("La validacion de buscar no fue exitosa, favor de verificar los datos o realizarla", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroPromocion.asuntoNeunId = this.idAsuntoNeun;
    }

    requestRegistroPromocion.catTipoOrganismoIdIOJ = this.authService.getTipoOrganismo();
    requestRegistroPromocion.oij = this.authService.getIdOrgan();
    requestRegistroPromocion.guidRel = this.uuid;

    //   console.log('TSTS')
    // console.log(requestRegistroPromocion)

    this.gatewayService.EnvioPromocion(requestRegistroPromocion).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succcess) {
          this.acuse = new AcuseDTO;
          this.acuse = response.data;

          const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
          modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          modalRef.componentInstance.response.subscribe((receivedEntry: any) => {
            this.reloadCurrentRoute();
          });

        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('error envio Promocion:', error.message);
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      }
    });


  }

  /**
   * Función para recargar la ruta actual, se obtiene la URL actual utilizando el router, se navega a la raíz de la aplicación sin cambiar la URL en el navegador, y luego se navega de nuevo a la URL original para forzar la recarga de la ruta y actualizar la vista con los cambios realizados
    * @returns
   */
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  /**
   * Función para obtener el acuse de la promoción, se llama al método GetAcusePromocion del servicio para obtener el acuse, si la consulta es exitosa se asigna el acuse a la propiedad acuse y se muestra un modal con los detalles del acuse
   * @param idPromocion 
   */
  getAcuse(idPromocion: number) {
    this.gatewayService.GetAcusePromocion(idPromocion).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succcess) {
          this.acuse = new AcuseDTO;
          this.acuse = response.data;

          const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
          modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          modalRef.componentInstance.response.subscribe((receivedEntry: any) => {
            this.reloadCurrentRoute();
          });

        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('error envio Promocion:', error.message);
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      }
    });
  }

  async openWindowFirma(): Promise<void> {
    if (this.uuid === "0") {
      this.uuid = uuidv4();
    }

    this.isLoadingFile = true;
    try {
      const signCompletedData = await this.firmador.openWindowFirma(this.uuid, this.constService.TipoDoctos.Promociones, this.bAcceptDocx);
      if (signCompletedData.length > 0) {
        this.lstDocumentos = signCompletedData;
      }
    } finally {
      this.isLoadingFile = false;
    }
  }

}

